import DHowProtection from './DHowProtection'

export default DHowProtection
